(() => {
 let pending = false;
 const opaque = value => value && value !== 'transparent' && !/rgba\([^)]*,\s*0(?:\.0+)?\s*\)$/.test(value) && !/rgb\([^)]*\/\s*0(?:\.0+)?\s*\)$/.test(value);
 const update = () => {
  pending = false;
  const main = document.getElementById('MainContent');
  if (!main) return;
  const surface = (main.dataset.template.startsWith('collection') && main.querySelector('.product-grid-container')) || main.querySelector('.bv-collection-heading,.product-information,.main-cart,.search-page__header') || main.querySelector('.product-grid-container');
  let color = surface ? getComputedStyle(surface).backgroundColor : getComputedStyle(main).backgroundColor;
  if (!opaque(color)) color = getComputedStyle(main).backgroundColor;
  if (main.dataset.template === 'index') color = getComputedStyle(main).getPropertyValue('--bv-home-master-bg').trim() || color;
  if (!opaque(color)) {
   const candidates = [...main.querySelectorAll('.section-background,.section')];
   color = candidates.map(node => getComputedStyle(node).backgroundColor).find(opaque);
  }
  if (!opaque(color)) color = getComputedStyle(document.body).backgroundColor;
  if (!opaque(color)) color = '#ffffff';
  const probe = document.createElement('span');probe.style.color=color;document.body.append(probe);const rgb=getComputedStyle(probe).color.match(/[\d.]+/g);probe.remove();const light=rgb && (Number(rgb[0])*0.299+Number(rgb[1])*0.587+Number(rgb[2])*0.114)>155;document.body.style.setProperty('--bv-page-ink',light?'#111111':'#ffffff');document.body.dataset.bvPageDark=String(!light);
  if (document.body.style.getPropertyValue('--bv-page-surface') !== color) document.body.style.setProperty('--bv-page-surface',color);
 };
 const schedule = () => {if (!pending) {pending=true;requestAnimationFrame(update);}};
 const updatePosition = () => {document.body.dataset.bvPageTop = String(window.scrollY <= 1);};
 updatePosition();
 window.addEventListener('scroll',updatePosition,{passive:true});
 update();
 window.addEventListener('load',schedule);
 if (window.Shopify?.designMode) window.setInterval(schedule,200);
 document.addEventListener('transitionend',schedule);
 window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',schedule);
 document.addEventListener('shopify:section:reorder',schedule);
 new MutationObserver(schedule).observe(document.head,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['style','href']});
 const main = document.getElementById('MainContent');
 if (main) new MutationObserver(schedule).observe(main,{subtree:true,childList:true,attributes:true,attributeFilter:['style','class']});
 new MutationObserver(schedule).observe(document.documentElement,{attributes:true,attributeFilter:['style','class']});
})();